export function getSpoId(document) {
    // Id is always going to be SPO ID for ODSP documents. Non-ODSP documents
    // would not start with "SPO_"
    if (document.id.indexOf('SPO_') === 0) {
        return document.id;
    }
    return undefined;
}
//# sourceMappingURL=getSpoId.js.map